// extracted by mini-css-extract-plugin
export default {"container":"more-games_container__nKbyC","container__games":"more-games_container__games__ESiO4"};